import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { RouteResponse } from "@gtpl/shared-models/hrms";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { LogsDto } from "libs/shared-models/user-logs/src/lib/Logs/logs.dto";
import { Raw, Repository } from "typeorm";
import { RouteDto } from "./dto/route.dto";
import { RouteRequest } from "./dto/route.request";
import { Route } from "./entity/route.entity";
import { RouteAdapter } from "./route.adapter";

@Injectable()
export class RouteService{
    constructor(
      private logService:LogsService,

        @InjectRepository(Route)
        private RouteRepository : Repository<Route>,
        private routeAdapter: RouteAdapter,
    ){}

    async getRouteDetailsWithoutRelations(routeId: number): Promise<Route> {
        // tslint:disable-next-line: typedef
        const RouteResponse = await this.RouteRepository.findOne({
        where: {routeId: Raw(alias => `route_id = '${routeId}'`)},
        });
        if (RouteResponse) {
        return RouteResponse;
        } else {
        return null;
        }
    }

    async createRoute(routeDto: RouteDto, isUpdate: boolean,request:Request): Promise<RouteResponse> {
        try {
            console.log(isUpdate);
            // to check whether Department exists with the passed  Department  or not. if isUpdate is false, a check will be done whether a record with the passed Department is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Department  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const RouteEntity = await this.getRouteDetailsWithoutRelations(routeDto.routeId);
                if (RouteEntity) {
                    // throw new ErrorResponse(11104, 'Department already exists');     
                    throw new RouteResponse(false,11104,"Route already existed");     
                } 
            // var notificationStatus='Created';
            }else{
                const RouteEntity = await this.getRouteDetailsWithoutRelations(routeDto.routeId);
                if(RouteEntity){
                    if(RouteEntity.routeId!=routeDto.routeId) {
                        // throw new ErrorResponse(11104, 'Department already exists');  
                        throw new RouteResponse(false,11104,"Route already existed");    
                    }
                }
            }

            // else{
            // var notificationStatus='Updated';
            // }
            const convertedRouteEntity: Route = this.routeAdapter.convertDtoToEntity(routeDto,isUpdate);
            const savedRouteEntity: Route = await this.RouteRepository.save(
            convertedRouteEntity
            );
            const savedRouteDto: RouteDto = this.routeAdapter.convertEntityToDto(savedRouteEntity);
            if (savedRouteDto) {
            // generating resposnse
            const response = new RouteResponse(true,isUpdate ? 11101 : 11100,isUpdate? 'Route Updated Successfully': 'Route Created Successfully',[savedRouteDto]);
            const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'Route', savedRouteDto.routeId, true, '',savedRouteDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new ErrorResponse(11106,'Route saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }


    async getAllRoute(): Promise<RouteResponse> {
        // const page: number = 1;
        try {
          const routeDto: RouteDto[] = [];
          //retrieves all companies
          const routeEntities: Route[] = await this.RouteRepository.find({order :{'createdAt':'DESC'}});
          //console.log(departmentsEntities);
          if (routeEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            routeEntities.forEach(routeEntity => {
              const convertedstatesDto: RouteDto = this.routeAdapter.convertEntityToDto(
                routeEntity
              );
              routeDto.push(convertedstatesDto);
            });
            const response = new RouteResponse(true,11108,"Route retrieved successfully",routeDto);
            const newLogDto = new LogsDto(1,'view', 'Route', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } catch (err) {
            return err;
        }
      }

      async getAllActiveRoute(): Promise<RouteResponse> {
        // const page: number = 1;
        try {
            const routeDto: RouteDto[] = [];
            //retrieves all companies
            const routeEntities: Route[] = await this.RouteRepository.find({ order: { 'routeNumber': 'ASC' },where:{ isActive : true}
           });
         console.log(routeEntities)
            if (routeEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                routeEntities.forEach(routeEntity => {
                    const convertedrouteDto: RouteDto = this.routeAdapter.convertEntityToDto(
                      routeEntity
                    );
                    routeDto.push(convertedrouteDto);
                });
                const response = new RouteResponse(true, 11108, "Route retrieved successfully", routeDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }


    async getRouteById(routeId: number): Promise<Route> {
        const Response = await this.RouteRepository.findOne({
        where: {routeId: routeId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }

    async activateOrDeactivateRoute(routeReq: RouteRequest): Promise<RouteResponse> {
        try {
            const routeExists = await this.getRouteById(routeReq.routeId);
            if (routeExists) {
                if (routeReq.versionFlag !== routeExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Route information.Refresh and try again');
                } else {
                    
                        const routeStatus =  await this.RouteRepository.update(
                            { routeId: routeReq.routeId },
                            { isActive: routeReq.isActive,updatedUser: routeReq.updatedUser });
                       
                        if (routeExists.isActive) {
                            if (routeStatus.affected) {
                                const routeResponse: RouteResponse = new RouteResponse(true, 10115, 'Route is de-activated successfully');
                                return routeResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Route is already deactivated');
                            }
                        } else {
                            if (routeStatus.affected) {
                                const routeResponse: RouteResponse = new RouteResponse(true, 10114, 'Route is activated successfully');
                                return routeResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Route is already activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
          return err;
        }
    }

}
